<template>
  <div class="resources">
    <leftTab title="Resources"></leftTab>
    <homeSwiper swiperID="2" :msgList="msgList"></homeSwiper>
  </div>
</template>

<script>
import leftTab from "@/components/leftTab/index.vue";
import homeSwiper from "@/components/swiper-free/index.vue";
export default {
  components: {
    leftTab,
    homeSwiper,
  },
  data() {
    return {
      //图片大小1：1.24
      msgList: [
        {
          id: "0",
          imgurl: require("@/assets/images/home/swiper1.png"),
          title: "News Sample",
          msg: "Here is some news or resources",
          index: "01",
          path:"/blog/0"
        },
        {
          id: "1",
          imgurl: require("@/assets/images/home/swiper2.png"),
          title: "News Sample",
          msg: "Here is some news or resources",
          index: "02",
          path:"/blog/0"
        },
        {
          id: "2",
          imgurl: require("@/assets/images/home/swiper3.png"),
          title: "News Sample",
          msg: "Here is some news or resources",
          index: "03",
          path:"/blog/0"
        },
        {
          id: "3",
          imgurl: require("@/assets/images/home/swiper4.png"),
          title: "News Sample",
          msg: "Here is some news or resources",
          index: "04",
          path:"/blog/0"
        },
        {
          id: "4",
          imgurl: require("@/assets/images/home/swiper1.png"),
          title: "News Sample",
          msg: "Here is some news or resources",
          index: "05",
          path:"/blog/0"
        },
        {
          id: "6",
          imgurl: require("@/assets/images/home/swiper2.png"),
          title: "News Sample",
          msg: "Here is some news or resources",
          index: "06",
          path:"/blog/0"
        },
        {
          id: "7",
          imgurl: require("@/assets/images/home/swiper3.png"),
          title: "News Sample",
          msg: "Here is some news or resources",
          index: "07",
          path:"/blog/0"
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.resources {
  margin-bottom: 1rem;
}

@media screen and (max-width: 760px) {
  .resources{
    padding: 0 0.3rem;
  }
}
</style>
